import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const GebaeudePage = lazy(() => import('../pages/nachhaltigkeit/page'));
const RaumMietenPage = lazy(() => import('../pages/raum-mieten/page'));
const NewsEventsPage = lazy(() => import('../pages/news-events/page'));
const ProWorkspaceBuchenPage = lazy(() => import('../pages/pro-workspace-buchen/page'));
const TourBuchenPage = lazy(() => import('../pages/tour-buchen/page'));
const BueroBuchenPage = lazy(() => import('../pages/buero-buchen/page'));
const DankeRaumPage = lazy(() => import('../pages/danke-raum/page'));
const DankeTourPage = lazy(() => import('../pages/danke-tour/page'));
const DankeBueroPage = lazy(() => import('../pages/danke-buero/page'));
const AGBProPage = lazy(() => import('../pages/agb-pro/page'));
const DatenschutzPage = lazy(() => import('../pages/datenschutz/page'));
const ImpressumPage = lazy(() => import('../pages/impressum/page'));
const AnfahrtPage = lazy(() => import('../pages/anfahrt/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/news-events',
    element: <NewsEventsPage />,
  },
  {
    path: '/nachhaltigkeit',
    element: <GebaeudePage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/raum-mieten',
    element: <RaumMietenPage />,
  },
  {
    path: '/tour-buchen',
    element: <TourBuchenPage />,
  },
  {
    path: '/buero-buchen',
    element: <BueroBuchenPage />,
  },
  {
    path: '/danke-raum',
    element: <DankeRaumPage />,
  },
  {
    path: '/danke-tour',
    element: <DankeTourPage />,
  },
  {
    path: '/danke-buero',
    element: <DankeBueroPage />,
  },
  {
    path: '/pro-workspace-buchen',
    element: <ProWorkspaceBuchenPage />,
  },
  {
    path: '/agb-pro',
    element: <AGBProPage />,
  },
  {
    path: '/datenschutz',
    element: <DatenschutzPage />,
  },
  {
    path: '/impressum',
    element: <ImpressumPage />,
  },
  {
    path: '/anfahrt',
    element: <AnfahrtPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;